import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    encryptedText: String,
    iv: String,
    sharedKey: String
  }

 connect() {
  const alreadyDecrypted = this.element.dataset.decrypted === "true"
  const placeholder = this.element.querySelector(".decrypted-text")

  if (alreadyDecrypted) {
    console.log("[Decrypt] Skipping: already decrypted")
    return
  }

  this.retryCount = 0
  if (placeholder && !placeholder.textContent.trim()) {
    placeholder.textContent = "📡 Decrypting..."
  }

  this.tryDecryptWithRetries()
}


  tryDecryptWithRetries() {
    const encryptedText = this.encryptedTextValue || this.element.getAttribute("data-decrypt-encrypted-text-value")
    const iv = this.ivValue || this.element.getAttribute("data-decrypt-iv-value")
    const sharedKey = this.sharedKeyValue || this.element.getAttribute("data-decrypt-shared-key-value")
  
    if (!encryptedText || !iv || !sharedKey) {
      if (this.retryCount++ < 30) { // ⬅ longer retry window: 3s total
        return setTimeout(() => this.tryDecryptWithRetries(), 100)
      } else {
        const p = this.element.querySelector(".decrypted-text")
        if (p) p.textContent = "❌ Could not decrypt"
      }
      return
    }
  
    this.decrypt(encryptedText, iv, sharedKey)
  }
  

  async decrypt(encryptedText, iv, sharedKey) {
    try {
      const key = await crypto.subtle.importKey(
        "raw",
        Uint8Array.from(atob(sharedKey), c => c.charCodeAt(0)),
        { name: "AES-GCM" },
        false,
        ["decrypt"]
      )

      const decrypted = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: Uint8Array.from(atob(iv), c => c.charCodeAt(0)) },
        key,
        Uint8Array.from(atob(encryptedText), c => c.charCodeAt(0))
      )

      const text = new TextDecoder().decode(decrypted)
      const p = this.element.querySelector(".decrypted-text")
      if (p) p.textContent = text

      this.element.dataset.decrypted = "true"
      requestAnimationFrame(() => {
        this.element.dispatchEvent(new CustomEvent("decrypt:ready", { bubbles: true, detail: { text } }))
      })
      console.log("[Decrypt] ✅", text)
    } catch (err) {
      console.error("🧨 Decryption failed:", err)
      const p = this.element.querySelector(".decrypted-text")
      if (p) p.textContent = "❌ Decryption error"
    }
  }
}
